import React from 'react'
import { NavLink } from 'src/components'
import SidebarItem from '../SidebarItem'
import styles from '../SidebarItem/SidebarItem.scss'

/**
 * An item for the Sidebar that acts as a NavLink.
 */
const LinkSidebarItem = props => <SidebarItem {...props} as={NavLink} activeClassName={styles.active} />

export default LinkSidebarItem
